<script>
import { onComponentEventAction, emitCustomEvent, emitPage, PageEventListenerTypes, generatePluginParams } from '@tencent/gems-shared';
import ComponentItem from './ComponentItem.vue';
import PositionHandler from './PositionHandler.vue';
import  ComponentActionHandler  from './actionHandler/ComponentActionHandler.vue';

export default {
  props: ['componentInstances', 'pluginInstances', 'global', 'meta'],
  components: {
    ComponentItem,
  },
  mounted: function () {
    this.$nextTick(function () {
      this.pluginInstances.forEach((plugin) => {
        const {
          plugin: { plugin: pluginFn },
        } = plugin;
        const params = generatePluginParams(plugin, this.global, this.meta);
        pluginFn(params);
      });
      emitPage(PageEventListenerTypes.INIT, { global: this.global, meta: this.meta });
      const start = new Date().getTime();
      window.addEventListener('beforeunload', () => {
        const end = new Date().getTime();
        // 监听关闭事件并计算浏览时长
        emitPage(PageEventListenerTypes.CLOSE, {
          global: this.global,
          meta: this.meta,
          addition: {
            visitDuration: end - start,
          },
        });
      });
    });
  },
  render(createElement) {
    function buildElements(instance, self) {
      const { component, data, style, commonStyle, key, children, position, slot } = instance;

      const emit = (trigger, payload) => emitCustomEvent(instance, trigger, self.global, self.meta, payload);
      const on = (eventName, callback) => onComponentEventAction(instance, eventName, callback);

      const content = createElement(
        ComponentActionHandler,
        {
          props: {
            instance,
            meta: self.meta,
            global: self.global,
          },
        },
        [
          createElement(
            ComponentItem,
            {
              key,
              props: {
                instance,
                meta: self.meta,
                global: self.global,
                componentKey: key,
                emit,
                on,
                slot,
              },
            },
            children &&
              children.map(function (child) {
                return buildElements(child, self);
              }),
          ),
        ],
      );

      if (position) {
        return createElement(
          PositionHandler,
          {
            props: {
              positionStyle: position,
              instance,
            },
          },
          [content],
        );
      } else {
        return content;
      }
    }

    return createElement(
      'div',
      this.componentInstances.map((instance) => {
        return buildElements(instance, this);
      }),
    );
  },
};
</script>
